import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from "../../../core/services/loader.service";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  loading: boolean = true;
  @Input() fetchedData: boolean=true; 
  constructor(private loaderService: LoaderService) {

    
  }
  ngOnChanges(){
    this.loading=this.fetchedData;
  }
  ngOnInit(): void {
  }

}
